
import { Loader2 } from "lucide-react";

export function ListingsLoadingState() {
  return (
    <div className="py-12 text-center">
      <Loader2 className="animate-spin h-8 w-8 mx-auto mb-4 text-primary" />
      <p>Loading properties...</p>
    </div>
  );
}
